import React, { Component } from "react";
import { ContentState, EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const TOOLBAR = {
  options: ["inline", "fontSize", "textAlign"],
  inline: { options: ["bold", "italic", "underline"] }
};

const toEditorState = (html) => {
  const blocks = html ? htmlToDraft(html) : null;
  return blocks && blocks.contentBlocks
    ? EditorState.createWithContent(
        ContentState.createFromBlockArray(blocks.contentBlocks, blocks.entityMap)
      )
    : EditorState.createEmpty();
};

// The Header / Footer editor from the Print Config form. Only reports real
// edits, so opening a section never rewrites the saved HTML.
class RichTextField extends Component {
  constructor(props) {
    super(props);
    this.state = { editorState: toEditorState(props.value) };
  }

  onChange = (editorState) => {
    const before = this.state.editorState.getCurrentContent();
    const after = editorState.getCurrentContent();
    this.setState({ editorState });
    if (before !== after) {
      this.props.onChange(draftToHtml(convertToRaw(after)));
    }
  };

  render() {
    return (
      <Editor
        editorState={this.state.editorState}
        onEditorStateChange={this.onChange}
        toolbar={TOOLBAR}
        wrapperClassName="pt-editor"
        editorClassName="pt-editor-body"
      />
    );
  }
}

export default RichTextField;
